// Shared helper for patching a single post's fields inside the
// ["workoutFeed"] infinite-query cache (used by like/save optimistic
// updates and by comment-count increments).
export function patchFeedPost(queryClient, postId, patch) {
  queryClient.setQueryData(["workoutFeed"], (data) => {
    if (!data) return data;
    return {
      ...data,
      pages: data.pages.map((page) => ({
        ...page,
        posts: page.posts.map((p) => (p.id === postId ? { ...p, ...patch } : p)),
      })),
    };
  });
}
